/**
 * Calculates the time zone offset for the current time zone
 * @returns {number} The time zone offset in seconds for the current time zone in seconds
 */
function getTimeZoneOffset() {
  const date = new Date()
  const offset = -(date.getTimezoneOffset() * 60)

  return offset
}

export default getTimeZoneOffset
